import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { API_PROVIDERS } from './services';

@NgModule({
  imports: [HttpClientModule],
  providers: [...API_PROVIDERS],
})
export class ApiModule {}
